import { t } from "i18next"
import { capitalizeFirstLetter, convertToReadableString } from "utils"

export const callTranscriptionTransformer = response => {
  return {
    transcription: response?.transcription?.replace("\r", "")?.split("\n"),
    summary: {
      description: response?.summary?.description,
      status: response?.summary?.leadQualificationStatus ? t("Qualified Lead") : t("Unqualified Lead"),
      level: convertToReadableString(response?.summary?.leadInterestLevel?.level)
    },
    //callTags: getCallTags(response?.callTags, response?.summary),
    clientInformation: Object.keys(response?.clientInformation?.client_information || {})?.length
      ? response?.clientInformation?.client_information
      : null,
    assessment: Object.keys(response?.assessment || {})?.length ? {scoring : response?.assessment} : null,
  }
}